"use client";
import { jsx as E } from "react/jsx-runtime";
import { createContext as I, useContext as U, useState as p, useCallback as u } from "react";
import { submitFeedback as M } from "../atoms/api/analytics/feedback.js";
import { useChat as N } from "../components/embedded-chat/chat-provider.js";
import { getMessageContent as f } from "../utils/misc.js";
import { useInkeepConfig as S } from "./config-provider.js";
import { useInkeepConversation as j } from "./conversation-provider.js";
import { useChatEvents as q } from "./chat-events-provider.js";
import { useUser as A } from "./user-provider.js";
const v = I(void 0);
function B() {
  const { baseSettings: e } = S(), { apiKey: s, analyticsApiBaseUrl: o } = e, [b, l] = p(null), [F, g] = p({}), { conversation: m } = j(), { messages: n, selectedWorkflow: C } = N(), { userProperties: h } = A(), { logEvent: w } = q(), r = u(
    async (t, i, c = []) => {
      const a = await M({
        type: i,
        messageId: t,
        reasons: c,
        apiKey: s,
        apiUrl: o,
        userProperties: h
      });
      a && g((d) => ({
        ...d,
        [t]: { type: a.type, reasons: a.reasons }
      }));
      const k = n.findIndex((d) => d.id === t), P = n[k], _ = {
        conversationId: m.id,
        question: f(n[k - 1]),
        answer: f(P),
        messageId: t,
        reasons: c,
        workflowId: C?.id
      };
      w({
        eventName: i === "positive" ? "assistant_positive_feedback_submitted" : "assistant_negative_feedback_submitted",
        properties: _
      });
    },
    [n, m]
  ), x = u(
    async (t) => {
      r(t, "positive");
    },
    [r]
  ), y = u(
    async (t, i) => {
      const c = K(i);
      r(t, "negative", c);
    },
    [r]
  );
  return {
    feedback: F,
    currentFeedback: b,
    setCurrentFeedback: l,
    submitPositiveFeedback: x,
    submitNegativeFeedback: y
  };
}
const O = ({ children: e }) => {
  const s = B();
  return /* @__PURE__ */ E(v.Provider, { value: s, children: e });
}, Q = () => {
  const e = U(v);
  if (!e)
    throw new Error("useFeedback must be used within a FeedbackProvider");
  return e;
};
function K(e) {
  const s = [];
  for (const o in e)
    e[o] === "on" && s.push({
      label: o,
      details: e[`${o}:description`] || ""
    });
  return s.length > 0 ? s : [];
}
export {
  O as FeedbackProvider,
  Q as useMessageFeedback
};
